import {EnvironmentSettings, EnvironmentsTypes} from './EnvironmentSettings'

export type EnvironmentVariable = { [key: string]: string | undefined }

class APISettings {
    public readonly ADMIN_PANEL_BASE_URL: string

    constructor(private envVariables: EnvironmentVariable) {
        this.ADMIN_PANEL_BASE_URL = envVariables.ADMIN_PANEL_BASE_URL || 'https://st-admin-beatmaker-tv-9aa58e633bab.herokuapp.com'
    }
}

class AppSettingsClass {
    constructor(
        public env: EnvironmentSettings,
        public api: APISettings,
    ) {
    }
}

const env = new EnvironmentSettings(
    (process.env.ENV || 'DEVELOPMENT') as EnvironmentsTypes
)
const api = new APISettings(process.env)


export const appSettings = new AppSettingsClass(env, api)
